export default __webpack_public_path__ + "static/media/DIP.ffbfe6ef.jpg";